import { useT } from "@transifex/react"
import { RewardDuration } from "./RewardDuration"

export const SuccessScreen = ({
  existing,
  created,
  rewardDuration,
  gympassToken,
  fitnessOnDemandToken,
  promoLinkToken,
}: {
  existing?: boolean
  created?: boolean
  rewardDuration: string | undefined
  gympassToken: string | undefined
  fitnessOnDemandToken: string | undefined
  promoLinkToken: string | undefined
}) => {
  const t = useT()
  let title
  if (rewardDuration) {
    title = t("Promo code redeemed!")
  } else if (gympassToken) {
    title = t("Wellhub activated!")
  } else if (fitnessOnDemandToken) {
    title = t("Fitness On Demand account linked!")
  } else if (promoLinkToken) {
    title = t("Success!")
  }
  let description
  if (rewardDuration) {
    description = (
      <>
        {t("You now have {duration} of premium subscription at Motosumo.", {
          duration: <RewardDuration rewardDuration={rewardDuration} />,
        })}
      </>
    )
  } else if (gympassToken) {
    description = <>{t("You now have Motosumo Premium access via Wellhub.")}</>
  } else if (fitnessOnDemandToken) {
    description = (
      <>{t("You now have Motosumo Premium access via Fitness On Demand.")}</>
    )
  } else if (promoLinkToken) {
    description = <>{t("You now have Motosumo Premium.")}</>
  }
  return (
    <>
      <div className="check-circle">
        <div className="check" />
      </div>

      <p className="App-title">{title}</p>
      <p className="App-description">
        {description}
        <br />
        {existing && <>{t("Open the app to start using it!")}</>}
        {created && (
          <>{t("Download the app and use your new account to sign in!")}</>
        )}
      </p>
      {existing && (
        <input
          className="App-button"
          type="button"
          value={t("Open Motosumo")}
          onClick={() => window.open("https://motosumo.link")}
        />
      )}
      {created && (
        <input
          className="App-button"
          type="button"
          value={t("Download Motosumo")}
          onClick={() => window.open("https://onelink.to/motosumo")}
        />
      )}
    </>
  )
}
